import { Icon } from '@types';

export const Calendar = ({ customStyles, handleClick }: Icon) => (
	<svg
		className={customStyles}
		onClick={handleClick}
		id="Layer_1"
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 74.8 65.51"
	>
		<defs>
			<style>
				{
					'.cls-calendar{fill:#fff;}.cls-calendar,.cls-calendar-2{stroke:#2e2d2c;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}.cls-calendar-2{fill:none;}'
				}
			</style>
		</defs>
		<rect
			className="cls-calendar-2"
			x={1}
			y={8.18}
			width={72.8}
			height={56.33}
			rx={4.05}
			ry={4.05}
		/>
		<g>
			<path
				className="cls-calendar"
				d="M58.17,15.37c-1.87,0-3.39-1.52-3.39-3.39V4.39c0-1.87,1.52-3.39,3.39-3.39s3.39,1.52,3.39,3.39v7.58c0,1.87-1.52,3.39-3.39,3.39Z"
			/>
			<path
				className="cls-calendar"
				d="M16.63,15.37c-1.87,0-3.39-1.52-3.39-3.39V4.39c0-1.87,1.52-3.39,3.39-3.39s3.39,1.52,3.39,3.39v7.58c0,1.87-1.52,3.39-3.39,3.39Z"
			/>
		</g>
		<line className="cls-calendar" x1={1} y1={22.51} x2={73.8} y2={22.51} />
		<g>
			<polyline className="cls-calendar" points="57.59 39.25 57.59 31.02 65.83 31.02" />
			<polyline className="cls-calendar" points="41.39 39.25 41.39 31.02 49.62 31.02" />
			<polyline className="cls-calendar" points="25.18 39.25 25.18 31.02 33.41 31.02" />
			<polyline className="cls-calendar" points="8.97 39.25 8.97 31.02 17.21 31.02" />
		</g>
		<g>
			<polyline className="cls-calendar" points="57.59 56 57.59 47.77 65.83 47.77" />
			<polyline className="cls-calendar" points="41.39 56 41.39 47.77 49.62 47.77" />
			<polyline className="cls-calendar" points="25.18 56 25.18 47.77 33.41 47.77" />
			<polyline className="cls-calendar" points="8.97 56 8.97 47.77 17.21 47.77" />
		</g>
	</svg>
);
